export const presetNameCharLimit = 50;
